
































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import FileDetailLayout from '@/views/Group/TopPage/SharedFolder/FileDetailLayout.vue'
import ModalFullImageViewer from '@/components/Modal/ModalFullImageViewer.vue'
import { FileDetail, EFileFormat, FileDetailFolder } from '@/models'
import CheckFileFormat from '@/helpers/CheckFileExtension'
import GroupSharedFolderService from '@/services/GroupSharedFolderService'
import CommonSharedFolderService from '@/services/CommonSharedFolderService'
import GroupService from '@/services/GroupService'
import { runDownload, downloadLabel, revokeObjectUrlLater } from '@/helpers/FileDownload'
import CheckDevice from '@/helpers/CheckDevice'
import linkifyHtml from "linkify-html";
import { getCommonTopicCount } from '@/helpers/GetNotificationCount'
import { getModule } from 'vuex-module-decorators'
import CommonTopic from '@/store/modules/CommonTopic'
import store from '@/store'
import {
  decodeHtml,
  extractTextAreaContentFromData,
  handleTranslation,
} from '@/helpers/Common'
import { ERR_API_KEY, TRANSLATION_TYPE } from '@/constants'

const CommonTopicModule = getModule(CommonTopic, store)
/**
 * f2-602
 * f2-704
 * グループ共有フォルダ - ファイル詳細
 * 共通トピック - ファイル詳細
 */
@Component({ components: { FileDetailLayout, ModalFullImageViewer } })
export default class FileDetailPage extends Vue {
  isCommonTopic = !this.$route.params.groupId
  file: FileDetail = new FileDetail()
  eFileFormat = EFileFormat
  modalMess: string = ''
  errorMess: string = ''
  canOpenFullImageModal: boolean = false

  created() {
    this.init()
  }

  @Watch('$route.params.fileId')
  init() {
    this.getFileDetail()
  }

  /**
   * Call API get file detail
   */

  getFileDetail() {
    setTimeout(async () => {
      await (this.$refs.fileDetailLayout as any).getFileDetail()
      this.file = (this.$refs.fileDetailLayout as any).currentFile
      this.handleMarkRead()
    }, 1)
  }

  /**
   * Handle mark read file
   */
  handleMarkRead() {
    if (this.isCommonTopic) {
      CommonSharedFolderService.markCommonFileAsRead(
        Number(this.$route.params.fileId)
      )
      getCommonTopicCount()
    } else {
      GroupSharedFolderService.markFileAsRead(
        this.$route.params.groupId,
        Number(this.$route.params.fileId)
      )
    }
    //handle rebind unred count
    CommonTopicModule.SET_RELOAD_UNREAD(true)
  }

  changeFolderName(name: FileDetailFolder) {
    this.file.folder = name
  }

  /**
   * API move file to folder
   */
  handleMoveToFolder(selectedFolder: FileDetailFolder) {
    this.$blockui.show()
    GroupSharedFolderService.moveFilesToFolder({
      group_id: this.$route.params.groupId,
      file_ids: [Number(this.$route.params.fileId)],
      folder_id: selectedFolder.id
    })
      .then(res => {
        if (res.status === 200) {
          this.file.folder = selectedFolder
        }
      })
      .catch(err => {
        if (err.response.status === 404) {
          const fileLayout = this.$refs.fileDetailLayout as any
          if (err.response.data.message === ERR_API_KEY.FILE_NOT_FOUND) {
            fileLayout.modalMess = this.$t(
              'common.message.file_not_exist'
            ) as string
            fileLayout.modalAction = () => this.jumpBack()
          } else if (err.response.data.message === ERR_API_KEY.FOLDER_NOT_FOUND) {
            fileLayout.modalMess = this.$t(
              'common.message.FOLDER_NOT_EXIST'
            ) as string
            fileLayout.modalAction = () => {}
          }
          this.$bvModal.show('modal-error-file-detail')
        }
      })
      .finally(() => this.$blockui.hide())
  }

  /**
   * Call API to get download files stream
   */
  downloadFile() {
    //handle dowload IOS not safari
    if (
      CheckDevice.iOSBrowerName().toLowerCase() !== CheckDevice.safari &&
      CheckDevice.isMobile() &&
      CheckDevice.getMobileOS() === CheckDevice.ios
    ) {
      window.open(this.file.path)
      return
    }

    //download other
    // 画面全体はブロックせず、右下に進捗とキャンセルを出す（NWS_SMILELINE-1936）
    // HTTP エラー（ファイルが消えた 404 など）は従来どおりこの画面のダイアログで知らせる。
    // タイムアウト・通信失敗は runDownload が右下に文言を出す
    const groupId = this.$route.params.groupId
    const fileId = this.file.id
    const fileName = this.file.name
    runDownload(
      downloadLabel([fileName]),
      config =>
        this.isCommonTopic
          ? CommonSharedFolderService.downloadCommonFiles([fileId], config)
          : GroupService.downloadFiles(groupId, [fileId], config),
      {
        key: `${this.isCommonTopic ? 'common' : `group-${groupId}`}-files:${fileId}`,
        // 応答が返る前に画面を離れていたら、この画面のダイアログは出さない
        owner: this,
        handleHttpError: err => {
          const layout = this.$refs.fileDetailLayout as any
          if (layout) layout.catchFileNotFoundErr(err)
          return true
        }
      }
    ).then(res => {
      if (res && res.status === 200) {
        this.hanldeDownloadFile(res, fileName)
      }
    })
  }

  hanldeDownloadFile(res: any, fileName: string) {
    const bytes = new Uint8Array(res.data)
    const blob = new Blob([bytes], { type: '*' })
    let a = document.createElement('a')
    const url = window.URL.createObjectURL(blob)
    a.href = url
    a.setAttribute('target', '_blank')
    a.setAttribute('download', fileName)
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    revokeObjectUrlLater(url)
  }

  jumpToParentTopic() {
    if (this.file.topic) {
      let router: any = {
        name: this.isCommonTopic
          ? 'common-topic-new-feed-topic-detail'
          : 'group-new-feed-topic-detail',
        params: {
          topicId: String(this.file.topic.id)
        },
        query: {}
      }
      this.file.comment_id
        ? (router.query.commentSearchId = this.file.comment_id)
        : ''
      return router
    }
  }

  openFullImage() {
    this.canOpenFullImageModal = true
  }

  /**
   * Jump back
   */
  jumpBack() {
    if (this.isCommonTopic) {
      this.$router.push({
        name: 'common-topic-shared-folder'
      })
    } else {
      this.$router.push({
        name: 'group-shared-folder'
      })
    }
  }

  getFileType(extension: string) {
    return CheckFileFormat.getFileFormat(extension)
  }

  getIconName(extension: string) {
    return CheckFileFormat.getIconClassName(this.getFileType(extension))
  }

  formatBytes(bytes: number) {
    if (bytes == 0) return '0 KB'
    if (bytes < 1) return '1 KB'
    const k = 1024
    const sizes = ['KB', 'MB', 'GB', 'TB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
  }

  handleLinkifyContent(content: string) {
    return linkifyHtml(content || '', { target: "_blank" });
  }

  async onTranslate() {
    // if already translation then back to default but still keep the cached translation
    if (this.file.isTranslated) {
      this.file = {
        ...this.file,
        isTranslated: false
      }
      return
    }

    const hasTitleTranslation = !!this.file.title_translation
    const hasContentTranslation = !!this.file.content_translation

    // if already have text translation then use it
    if (hasTitleTranslation && hasContentTranslation) {
      this.file = { ...this.file, isTranslated: true }
      return
    }

    const q: string[] = []
    const mapList: { field: 'title' | 'memo'; index: number }[] = []
    let memoLineInfos: { indent: string; content: string }[] = []

    const rawTitle = this.file.title?.trim()
    const needTranslateTitle = !hasTitleTranslation && rawTitle

    if (needTranslateTitle) {
      mapList.push({ field: 'title', index: q.length })
      q.push(rawTitle)
    }

    // handle memo before translation
    const rawMemo = this.file.memo?.trim()
    const needTranslateMemo = !hasContentTranslation && rawMemo

    if (needTranslateMemo) {
      const rawLines = extractTextAreaContentFromData(rawMemo)
      memoLineInfos = rawLines.map(line => ({
        indent: line.indent,
        content: this.handleLinkifyContent(line.content)
      }))

      const memoLines = memoLineInfos
        .filter(line => line.content.trim())
        .map(line => line.content)

      if (memoLines.length) {
        mapList.push({ field: 'memo', index: q.length })
        q.push(...memoLines)
      }
    }

    if (!q.length) {
      this.file = { ...this.file, isTranslated: true }
      return
    }

    await handleTranslation({
      modalId: 'file-detail-translation-error-modal',
      q,
      onSuccess: async (res: any) => {
        const translations =
          res?.map((t: any) => decodeHtml(t.translatedText)) || []

        const newFile = { ...this.file, isTranslated: true }

        mapList.forEach(map => {
          if (map.field === 'title') {
            if (!this.file.title_translation) {
              newFile.title_translation = translations[map.index] || ''
            }
          }

          if (map.field === 'memo') {
            if (!this.file.content_translation) {
              const memoTranslations = translations.slice(
                map.index,
                map.index + memoLineInfos.length
              )

              const translatedMemo = memoLineInfos
                .map((line, i) => {
                  const translated = memoTranslations[i] || ''
                  return line.indent + translated
                })
                .join('\n')

              newFile.content_translation = translatedMemo
            }
          }
        })

        this.file = newFile

        return {
          target_id: newFile.id,
          type: TRANSLATION_TYPE.TOPIC_SHARED_FOLDER,
          content_translation: newFile.content_translation,
          title_translation: newFile.title_translation
        }
      },
      onError: (message: string) => {
        this.errorMess = message
      },
    })
  }
}
